// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-member-search-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
  background: #f3f3f3;
  border: 1px solid #e0e0e0;
}

.list-member-search-name {
  font-size: 1rem;
  color: #222;
  margin-right: 10px;
}
.list-feed-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.list-feed-header {
  padding: 16px 16px 12px;
  border-bottom: 1px solid var(--border-color);
}

.list-feed-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.list-feed-back {
  color: var(--text-secondary);
  font-size: 13px;
  text-decoration: none;
}

.list-feed-back:hover {
  color: var(--text-primary);
}

.list-feed-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.list-rename-btn {
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.list-rename-btn:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.list-delete-btn {
  background: none;
  border: 1px solid var(--error-color, #e05252);
  color: var(--error-color, #e05252);
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.list-delete-btn:hover {
  background: var(--error-color, #e05252);
  color: #fff;
}

.list-feed-rename-form {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
}

.list-feed-rename-input {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  background: var(--bg-secondary);
  border: 1px solid var(--accent-primary);
  border-radius: 6px;
  padding: 4px 8px;
  outline: none;
  flex: 1 1;
  max-width: 320px;
}

.list-rename-submit-btn,
.list-rename-cancel-btn {
  font-size: 12px;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
}

.list-rename-submit-btn {
  background: var(--accent-primary);
  color: #fff;
  border: none;
}

.list-rename-submit-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.list-rename-cancel-btn {
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
}

.list-feed-title {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.list-feed-meta {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.list-member-search-wrap {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.list-member-search-input {
  width: 100%;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  padding: 10px 12px;
  font-size: 14px;
}

.list-member-search-status {
  font-size: 12px;
  color: var(--text-secondary);
}

.list-member-search-results {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
}

.list-member-search-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.list-member-search-item:last-child {
  border-bottom: none;
}


.list-member-search-link {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.list-member-search-link-centered {
  justify-content: center;
}
.list-member-search-link-left {
  justify-content: flex-start;
}

.list-member-search-name {
  font-size: 1rem;
  color: #fff;
  margin-right: 0;
}

.list-member-search-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
  background: #f3f3f3;
  border: 1px solid #e0e0e0;
}

.list-member-search-link:hover {
  color: var(--accent-primary);
}

.list-member-add-btn {
  border: 1px solid var(--accent-primary);
  border-radius: 6px;
  background: transparent;
  color: var(--accent-primary);
  cursor: pointer;
  padding: 4px 10px;
  font-size: 12px;
}

.list-member-add-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.list-feed-content {
  flex: 1 1;
  padding: 8px 0;
}

.list-feed-error,
.list-feed-empty {
  padding: 24px 16px;
  color: var(--text-secondary);
  font-size: 14px;
}

.load-more-btn {
  display: block;
  width: calc(100% - 32px);
  margin: 12px 16px;
  padding: 10px;
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
}

.load-more-btn:hover {
  background: var(--hover-bg, rgba(255,255,255,0.06));
}

.load-more-btn:disabled {
  opacity: 0.5;
  cursor: wait;
}

/* Member list (ListDetail) */
.list-detail-members {
  list-style: none;
  margin: 0;
  padding: 0;
}

.list-detail-member-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border-color);
}

.list-detail-member-link {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--text-primary);
  min-width: 0;
}

.list-detail-member-link:hover {
  color: var(--text-primary);
}

.list-detail-member-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.list-detail-member-name {
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-detail-remove-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 18px;
  line-height: 1;
  padding: 4px 6px;
  cursor: pointer;
  border-radius: 4px;
  flex-shrink: 0;
}

.list-detail-remove-btn:hover {
  color: var(--error-color, #e05252);
  background: var(--hover-bg, rgba(255,255,255,0.06));
}

.list-detail-remove-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ListFeed.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".list-member-search-avatar {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  margin-right: 8px;\r\n  background: #f3f3f3;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.list-member-search-name {\r\n  font-size: 1rem;\r\n  color: #222;\r\n  margin-right: 10px;\r\n}\r\n.list-feed-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n}\r\n\r\n.list-feed-header {\r\n  padding: 16px 16px 12px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.list-feed-header-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.list-feed-back {\r\n  color: var(--text-secondary);\r\n  font-size: 13px;\r\n  text-decoration: none;\r\n}\r\n\r\n.list-feed-back:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.list-feed-header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.list-rename-btn {\r\n  background: none;\r\n  border: 1px solid var(--border-color);\r\n  color: var(--text-secondary);\r\n  border-radius: 6px;\r\n  padding: 4px 10px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.list-rename-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.list-delete-btn {\r\n  background: none;\r\n  border: 1px solid var(--error-color, #e05252);\r\n  color: var(--error-color, #e05252);\r\n  border-radius: 6px;\r\n  padding: 4px 10px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.list-delete-btn:hover {\r\n  background: var(--error-color, #e05252);\r\n  color: #fff;\r\n}\r\n\r\n.list-feed-rename-form {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.list-feed-rename-input {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--accent-primary);\r\n  border-radius: 6px;\r\n  padding: 4px 8px;\r\n  outline: none;\r\n  flex: 1;\r\n  max-width: 320px;\r\n}\r\n\r\n.list-rename-submit-btn,\r\n.list-rename-cancel-btn {\r\n  font-size: 12px;\r\n  border-radius: 6px;\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.list-rename-submit-btn {\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n  border: none;\r\n}\r\n\r\n.list-rename-submit-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n.list-rename-cancel-btn {\r\n  background: none;\r\n  border: 1px solid var(--border-color);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.list-feed-title {\r\n  margin: 0 0 4px;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.list-feed-meta {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.list-member-search-wrap {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.list-member-search-input {\r\n  width: 100%;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  padding: 10px 12px;\r\n  font-size: 14px;\r\n}\r\n\r\n.list-member-search-status {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.list-member-search-results {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.list-member-search-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.list-member-search-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n\r\n.list-member-search-link {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  font-size: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.list-member-search-link-centered {\r\n  justify-content: center;\r\n}\r\n.list-member-search-link-left {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.list-member-search-name {\r\n  font-size: 1rem;\r\n  color: #fff;\r\n  margin-right: 0;\r\n}\r\n\r\n.list-member-search-avatar {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  margin-right: 8px;\r\n  background: #f3f3f3;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.list-member-search-link:hover {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.list-member-add-btn {\r\n  border: 1px solid var(--accent-primary);\r\n  border-radius: 6px;\r\n  background: transparent;\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  padding: 4px 10px;\r\n  font-size: 12px;\r\n}\r\n\r\n.list-member-add-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.list-feed-content {\r\n  flex: 1;\r\n  padding: 8px 0;\r\n}\r\n\r\n.list-feed-error,\r\n.list-feed-empty {\r\n  padding: 24px 16px;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n}\r\n\r\n.load-more-btn {\r\n  display: block;\r\n  width: calc(100% - 32px);\r\n  margin: 12px 16px;\r\n  padding: 10px;\r\n  background: none;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.load-more-btn:hover {\r\n  background: var(--hover-bg, rgba(255,255,255,0.06));\r\n}\r\n\r\n.load-more-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: wait;\r\n}\r\n\r\n/* Member list (ListDetail) */\r\n.list-detail-members {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.list-detail-member-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.list-detail-member-link {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  text-decoration: none;\r\n  color: var(--text-primary);\r\n  min-width: 0;\r\n}\r\n\r\n.list-detail-member-link:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.list-detail-member-avatar {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.list-detail-member-name {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.list-detail-remove-btn {\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-secondary);\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  padding: 4px 6px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.list-detail-remove-btn:hover {\r\n  color: var(--error-color, #e05252);\r\n  background: var(--hover-bg, rgba(255,255,255,0.06));\r\n}\r\n\r\n.list-detail-remove-btn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
